import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from 'react-skeleton-loader';
import classNames from 'classnames';

import s from './SkeletonLoader.module.scss';

const COLOR = '#F9F9F9';
const BORDER_RADIUS = '4px';
const WIDTH_RANDOMNESS = 0;

// Width and heights
const WIDTH_XSMALL = '24px';
const WIDTH_SMALL = '120px';
const WIDTH_MEDIUM = '134px';
const WIDTH_LARGE = '198px';
const WIDTH_XLARGE = '100%';
const HEIGHT_XSMALL = '16px';
const HEIGHT_SMALL = '24px';
const HEIGHT_MEDIUM = '32px';
const HEIGHT_LARGE = '62px';
const HEIGHT_XLARGE = '237px';

const SkeletonRow = ({ className, width, height }) => (
    <div className={className}>
        <Skeleton width={width} height={height} color={COLOR} borderRadius={BORDER_RADIUS} widthRandomness={WIDTH_RANDOMNESS} />
    </div>
);

SkeletonRow.propTypes = {
    className: PropTypes.string,
    width: PropTypes.string.isRequired,
    height: PropTypes.string.isRequired,
};

SkeletonRow.defaultProps = { className: '' };

const SkeletonLoader = () => (
    <div className={s.skeletonLoaderContainer}>
        <div className={s.skeletonLoader}>
            <div className={s.topStyling}>
                <SkeletonRow width={WIDTH_SMALL} height={HEIGHT_SMALL} />
                <SkeletonRow className={s.deleteSkeleton} width={WIDTH_XSMALL} height={HEIGHT_SMALL} />
                <SkeletonRow className={s.editSkeleton} width={WIDTH_XSMALL} height={HEIGHT_SMALL} />
                <button className={classNames('icon-close', s.closeButton)} onClick={() => {}} type="button" />
            </div>
            <SkeletonRow className={s.marginMedium} width={WIDTH_SMALL} height={HEIGHT_MEDIUM} />
            <SkeletonRow className={s.marginMedium} width={WIDTH_XLARGE} height={HEIGHT_LARGE} />
            <SkeletonRow className={s.marginMedium} width={WIDTH_MEDIUM} height={HEIGHT_SMALL} />
            <div className={s.divider} />
            <SkeletonRow className={s.marginLarge} width={WIDTH_LARGE} height={HEIGHT_XSMALL} />
            <SkeletonRow className={s.marginSmall} width={WIDTH_MEDIUM} height={HEIGHT_SMALL} />
            <SkeletonRow className={s.marginMedium} width={WIDTH_LARGE} height={HEIGHT_XSMALL} />
            <SkeletonRow className={s.marginLarge} width={WIDTH_XLARGE} height={HEIGHT_XLARGE} />
            <SkeletonRow className={s.marginSmall} width={WIDTH_MEDIUM} height={HEIGHT_SMALL} />
            <SkeletonRow className={s.marginLarge} width={WIDTH_XLARGE} height={HEIGHT_XSMALL} />
            <SkeletonRow className={s.marginSmall} width={WIDTH_MEDIUM} height={HEIGHT_SMALL} />
            <SkeletonRow className={s.marginMedium} width={WIDTH_LARGE} height={HEIGHT_XSMALL} />
            <SkeletonRow className={s.marginMedium} width={WIDTH_XLARGE} height={HEIGHT_XLARGE} />
        </div>
    </div>
);

export default SkeletonLoader;
